import { render, staticRenderFns } from "./AddressManager.vue?vue&type=template&id=0d91f1d2&scoped=true&"
import script from "./AddressManager.vue?vue&type=script&lang=js&"
export * from "./AddressManager.vue?vue&type=script&lang=js&"
import style0 from "./AddressManager.vue?vue&type=style&index=0&id=0d91f1d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d91f1d2",
  null
  
)

export default component.exports